class Newsletter {
  buttons: NodeListOf<HTMLButtonElement>;
  list: HTMLElement | null;

  constructor() {
    this.buttons = document.querySelectorAll('.newsletter-list__btn');
    this.list = document.querySelector('.newsletter-list__list');

    if (this.buttons.length && this.list) {
      this.init();
    }
  }

  init() {
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const form = btn.nextElementSibling as HTMLFormElement | null;

        if (!form || !form.classList.contains('newsletter-list__form')) return;

        btn.classList.toggle('active');
        this.list!.classList.toggle('active');
        this.toggleSlide(form);
      });
    });
  }

  toggleSlide(element: HTMLElement) {
    if (element.style.maxHeight) {
      element.style.maxHeight = '';
    } else {
      element.style.maxHeight = element.scrollHeight + 'px';
    }
  }
}

export const simple = new Newsletter();

